var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightHamburgerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 14.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lightHamburgerIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-5271.1,1654.73h25a0.5,0.5,0,0,0,.5-0.5,0.5,0.5,0,0,0-.5-0.5h-25a0.5,0.5,0,0,0-.5.5,0.5,0.5,0,0,0,.5.5",
    transform: "translate(5271.6 -1653.73)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-5271.1,1661.32h25a0.5,0.5,0,0,0,.5-0.5,0.5,0.5,0,0,0-.5-0.5h-25a0.5,0.5,0,0,0-.5.5,0.5,0.5,0,0,0,.5.5",
    transform: "translate(5271.6 -1653.73)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-5271.1,1667.91h25a0.5,0.5,0,0,0,.5-0.5,0.5,0.5,0,0,0-.5-0.5h-25a0.5,0.5,0,0,0-.5.5,0.5,0.5,0,0,0,.5.5",
    transform: "translate(5271.6 -1653.73)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightHamburgerIcon);
export default __webpack_public_path__ + "static/media/lightHamburgerIcon.58d7a54ccf6269fa7033276d6220a7a7.svg";
export { ForwardRef as ReactComponent };